// React dependencies
import React from 'react';

// External dependencies
import { Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';

// Internal dependencies
import { IsEmpty } from '../../../common/util';

const SocialLinksModal = (props) => (
  <Dialog
    open={props.open}
    onClose={props.onClose}
    fullWidth
    maxWidth="sm"
    autoFocus={false}
  >
    <DialogTitle style={{ paddingRight: 48, position: 'relative' }}>
      {`View${IsEmpty(props.title) ? ' ' : props.title}Links`}
      <IconButton
        aria-label="close"
        onClick={props.onClose}
        className="position-absolute"
        style={{ right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      {props.link.split('\n').map((url) => {
        const fullUrl = url.startsWith('http://') || url.startsWith('https://')
          ? url
          : `http://${url}`;
        return (
          <div className="mb-2" key={url}>
            <a
              href={fullUrl}
              target="_blank"
              rel="noreferrer"
              style={{ fontSize: 12 }}
            >
              {url}
            </a>
            <br />
          </div>
        );
      })}
    </DialogContent>
  </Dialog>
);

SocialLinksModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  title:   PropTypes.string.isRequired,
  link:    PropTypes.string.isRequired,
  open:    PropTypes.bool.isRequired,
};

export default SocialLinksModal;
